export default __webpack_public_path__ + "static/media/3Bestfriend.1fff52b0.png";